// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"7f0ba26a","213":"73eab333","354":"fcb9b143","455":"b621b647","488":"d08d609e","685":"55072244","888":"f474c786"}[chunkId] + ".chunk.js";
};